import { useCheckoutCustomerContext } from "../../checkoutCustomer.context";

const BoxContestConditionComponent = () => {
    const { boxContestConditionInfo } = useCheckoutCustomerContext();
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: boxContestConditionInfo
            }}
        />
    );
};

export { BoxContestConditionComponent };
